module.exports = __webpack_public_path__ + "img/view 1.a38625de.svg";